const RoleKeys = {
  all: ['Roles'] as const,
  lists: () => [...RoleKeys.all, 'list'] as const,
};

export { RoleKeys };
